/* eslint-disable */

function parseList(list, foreach)
{
  const length = list.length
  if (length <= 0 || typeof foreach !== 'function') return
  for (let i = 0; i < length; i++) {
    foreach(list[i], i, list)
  }
}

export default class DropAsset {
  constructor(target, onFile) {
    this.target = target
    this.onFile = onFile
    this._initTarget()
  }

  static fileToDataURL(file, onComplete) {
    const reader = new FileReader()
    reader.addEventListener('loadend', function ({ currentTarget }) {
      typeof onComplete === 'function' && onComplete(currentTarget.result)
    })
    reader.readAsDataURL(file)
  }

  static fileToText(file, onComplete) {
    const reader = new FileReader()
    reader.addEventListener('loadend', function ({ currentTarget }) {
      typeof onComplete === 'function' && onComplete(currentTarget.result)
    })
    reader.readAsText(file)
  }

  /** @private */
  _initTarget() {
    this.target.classList.add('js-drop-asset')
    this.target.addEventListener('drop', (e) => { this._dropHandler(e) })
    this.target.addEventListener('dragover', (e) => { this._dragOverHandler(e) })
  }

  _dragOverHandler(e) {
    e.preventDefault()
    this.target.classList.add('js-drop-asset--over')
  }

  _dropHandler(e) {
    e.preventDefault()
    this.target.classList.remove('js-drop-asset--over')

    const files = []

    if (e.dataTransfer.items) {
      parseList(e.dataTransfer.items, item => {
        item.kind === 'file' && files.push(item.getAsFile())
      })
    } else {
      parseList(e.dataTransfer.files, item => {
        files.push(file)
      })
    }

    typeof this.onFile === 'function' && this.onFile(files)
  }
}
